import type { FileTableDisplayRow, FileTableRow } from '@/components/Views/Company/File/file-table.types';
import type { FileDetails } from '@/components/Views/Company/File/file.types';
import { formatDate, MONTH_DAY_YEAR_FORMAT } from '@/shared/utils/format-date';
import { formatCentsAsMoney } from '@/shared/utils/format-number';

export const hasStreetView = (
    file?: Pick<FileDetails, 'address' | 'street_view_url'>,
): file is { address: string; street_view_url: string } => {
    return !!file?.address && !!file?.street_view_url;
};

export const toFileTableDisplayRow = (file: FileTableRow): FileTableDisplayRow => ({
    ...file,
    balance_due_formatted: file.balance_due !== null ? formatCentsAsMoney(file.balance_due) : '',
    close_date: formatDate(file.close_date, MONTH_DAY_YEAR_FORMAT),
    created_at: formatDate(file.created_at, MONTH_DAY_YEAR_FORMAT),
    updated_at: formatDate(file.updated_at, MONTH_DAY_YEAR_FORMAT),
    company: file.company?.name ?? '',
});
